import { Box, Text } from '@chakra-ui/react'
import React from 'react'

import { borderVariant25, defaultBorder3 } from '@/chakraTheme.js'

const CategoriesSelector = ({
    emojiData,
    selectedEmoji,
    selectedCategories,
    setSelectedCategories,
}) => {
    return (
        <Box
            mt={6}
            display="flex"
            flexWrap="wrap"
            justifyContent={'center'}
            lineHeight={4}
            gap={3}
        >
            {emojiData
                .find(emoji => emoji.name === selectedEmoji)
                .categories.map(category => {
                    const [key, value] = Object.entries(category)[0]
                    const isSelected = selectedCategories.includes(key)

                    return (
                        <Box
                            key={key}
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            paddingX={4}
                            paddingY={3}
                            cursor="pointer"
                            backgroundColor={
                                isSelected ? 'mischka2' : 'athensgray4'
                            }
                            border={
                                isSelected ? borderVariant25 : defaultBorder3
                            }
                            onClick={() =>
                                setSelectedCategories(prev =>
                                    isSelected
                                        ? prev.filter(
                                              category => category !== key
                                          )
                                        : [...prev, key]
                                )
                            }
                            transition="all 0.2s ease-in-out"
                            _hover={{
                                transform: 'scale(1.05)',
                            }}
                        >
                            <Text fontSize="sm" fontFamily="Roboto">
                                {value.title}
                            </Text>
                        </Box>
                    )
                })}
        </Box>
    )
}

export default CategoriesSelector
